var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3125 4.61182H2.6875",
    stroke: "#D74120",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2702 6.17432L11.9827 10.4863C11.8721 12.1456 11.8168 12.9753 11.2761 13.481C10.7355 13.9868 9.90402 13.9868 8.24102 13.9868H7.75765C6.09467 13.9868 5.26317 13.9868 4.72254 13.481C4.18191 12.9753 4.1266 12.1456 4.01598 10.4863L3.72852 6.17432",
    stroke: "#D74120",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4375 7.73682L6.75 10.8618",
    stroke: "#D74120",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 7.73682L9.25 10.8618",
    stroke: "#D74120",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5625 4.61182C4.59742 4.61182 4.61489 4.61182 4.63072 4.61142C5.14537 4.59837 5.59939 4.27114 5.77451 3.78702C5.7799 3.77212 5.78542 3.75556 5.79646 3.72242L5.85714 3.54039C5.90894 3.38499 5.93484 3.30729 5.96919 3.24132C6.10626 2.97811 6.35984 2.79534 6.65288 2.74855C6.72633 2.73682 6.80825 2.73682 6.97206 2.73682H9.02794C9.19175 2.73682 9.27369 2.73682 9.34713 2.74855C9.64019 2.79534 9.89375 2.97811 10.0308 3.24132C10.0652 3.30729 10.0911 3.38499 10.1429 3.54039L10.2036 3.72242C10.2146 3.75552 10.2201 3.77214 10.2255 3.78702C10.4006 4.27114 10.8546 4.59837 11.3693 4.61142C11.3851 4.61182 11.4026 4.61182 11.4375 4.61182",
    stroke: "#D74120"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.3a6be8e5b6063681f37ae28be904b7e0.svg";
export { ForwardRef as ReactComponent };